export function DMTypingIndicator({ name, isDarkMode }) {
  if (!name) return null
  return (
    <div className={`flex items-center gap-2 px-4 py-2 text-xs ${isDarkMode ? 'text-slate-400' : 'text-gray-500'}`}>
      <span className="flex gap-0.5">
        {[0, 1, 2].map(i => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-sfp-orange animate-bounce"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </span>
      <span>{name} is typing…</span>
    </div>
  )
}
